module.exports = __webpack_public_path__ + "static/media/aws.3dd7cd90.svg";